module.exports = __webpack_public_path__ + "img/turn-right.fc1f7125.svg";